import React, { useMemo, useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import UserDataHome from "../components/user-data-home";
import Footer from "../components/footer";
import OrdemCarregamentoPanel from "../components/ordem-carregamento-panel";
import { PEDIDOS_PRONTOS_MOCK } from "../mocks/pedidos-prontos-carregamento";

const OrdemCarregamentoExecucaoPage = () => {
  const navigate = useNavigate();
  const { pedidoId } = useParams();
  const location = useLocation();

  const pedido = useMemo(() => {
    if (location.state?.pedido) return location.state.pedido;
    return PEDIDOS_PRONTOS_MOCK.find((p) => p.id === pedidoId) || null;
  }, [location.state, pedidoId]);

  const [veiculosSelecionados, setVeiculosSelecionados] = useState([]);

  const produtosPedido = useMemo(
    () =>
      (pedido?.itens || []).map((item) => ({
        codigo: item.codigo,
        descricao: item.descricao,
        volume: item.volume,
        um: item.um || "L",
      })),
    [pedido],
  );

  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <UserDataHome />
      <Box flex="1" py={{ base: 4, md: 6 }} px={{ base: 4, md: 6 }}>
        <Box maxW="1400px" mx="auto">
          <Button
            leftIcon={<FaArrowLeft />}
            variant="outline"
            colorScheme="blue"
            mb={4}
            onClick={() => navigate("/ordem-carregamento")}
          >
            Voltar aos pedidos
          </Button>

          {pedido && (
            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                Pedido #{pedido.numero}
              </Text>
              <Text fontWeight="bold" color="gray.800" fontSize="lg">
                {pedido.cliente}
              </Text>
              <Text fontSize="sm" color="gray.600">
                {pedido.codigoCliente}/{pedido.loja} · {pedido.cidade}
              </Text>
            </Box>
          )}

          <OrdemCarregamentoPanel
            rowItem={pedido}
            produtosPedido={produtosPedido}
            veiculosSelecionados={veiculosSelecionados}
            onVeiculosChange={setVeiculosSelecionados}
          />
        </Box>
      </Box>
      <Footer />
    </Flex>
  );
};

export default OrdemCarregamentoExecucaoPage;
